import DodoablesList from 'app/dodoables/list/Index'
import useDodoableCollectionQuery from 'generated/api/dodoables/useDodoableCollectionQuery'
import LoadingScreen from 'app/components/LoadingScreen'
import ConfirmableSpinnableButton from 'app/components/buttons/ConfirmableSpinnable'
import Dodoable from 'models/dodoable'
import { useMutation } from '@tanstack/react-query'
import destroyModelMember from 'braindamage/api/destroyModelMember'

const DodoableTreeItem = ({ dodoable }) => {
  const destroyDodoable = useMutation({
    mutationFn: async () => {
      return destroyModelMember(`/api/dodoables/${dodoable.id}.json`, Dodoable)
    }
  })

  const destroy = useCallback(() => {
    destroyDodoable.mutate({
      onSettled: async () => {
        console.log('oi')
      }
    })
  })

  return (
    <div className="fcol flex-1">
      <div className="frow">
        <div className="mr-2">{dodoable.name}</div>
        <ConfirmableSpinnableButton
          onConfirm={destroy}
          inlineLabel={true}
          size="xs"
          className=""
        >
          <i className="ph ph-trash" />
        </ConfirmableSpinnableButton>
      </div>
      {dodoable.children.length > 0 && (
        <div className="fcol flex-1 pl-6">
          <DodoablesList
            dodoables={dodoable.children}
            ListItemElement={DodoableTreeItem}
            scroll={false}
          />
        </div>
      )}
    </div>
  )
}

export default () => {
  const { isPending, data: { dodoables } = {} } = useDodoableCollectionQuery({
    query: { hierachy: true }
  })

  if (isPending) return <LoadingScreen />

  return (
    <DodoablesList dodoables={dodoables} ListItemElement={DodoableTreeItem} />
  )
}
